export default function initAvisListeForm(): void {
    document.querySelectorAll<HTMLFormElement>('.js-avis-liste-form').forEach($container => {
        new AvisListeForm($container);
    });
}

class AvisListeForm {
    $container: HTMLFormElement;
    $btnsClearFilters: NodeListOf<HTMLButtonElement>;
    $selects: NodeListOf<HTMLSelectElement>;
    $radios: NodeListOf<HTMLInputElement>;

    constructor($container: HTMLFormElement) {
        this.$container = $container;
        this.$btnsClearFilters = this.$container.querySelectorAll<HTMLButtonElement>('.js-clear-filters');
        this.$selects = this.$container.querySelectorAll<HTMLSelectElement>('select');
        this.$radios = this.$container.querySelectorAll<HTMLInputElement>('input[type="radio"]');

        // Le choix de la ville efface les autres filtres
        this.$selects.forEach(select => {
            select.addEventListener('change', () => {
                this.$radios.forEach(radio => {
                    radio.checked = false;
                });
            });
        });
        
        this.$container.addEventListener('change', () => this.$container.submit());

        this.$btnsClearFilters.forEach(btn => {
            btn.addEventListener('click', () => {
                // Réinitialiser les selects
                this.$selects.forEach(select => {
                    select.selectedIndex = 0;
                });

                // Décocher toutes les radios
                this.$radios.forEach(radio => {
                    radio.checked = false;
                });

                this.$container.submit();
            });
        });
    }
}
